module.exports = __webpack_public_path__ + "img/Army.899cd911.jpg";